(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnouncement(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('.custom-announcement__item'));
      if (items.length <= 1) return;

      var interval = parseInt(root.getAttribute('data-slide-interval'), 10) || 3500;
      var index = 0;
      var timer = null;
      var isMobile = false;

      function setActive(i) {
        items.forEach(function (item, idx) {
          item.classList.toggle('is-active', idx === i);
        });
      }

      function next() {
        index = (index + 1) % items.length;
        setActive(index);
      }

      function start() {
        stop();
        if (!isMobile || items.length < 2) return;
        timer = setInterval(next, interval);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function checkMode() {
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        if (mobile === isMobile && root.dataset.modeReady === 'true') return;
        isMobile = mobile;
        root.dataset.modeReady = 'true';

        if (isMobile) {
          setActive(index);
          start();
        } else {
          stop();
          items.forEach(function (item) {
            item.classList.remove('is-active');
          });
        }
      }

      checkMode();
      window.addEventListener('resize', checkMode);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else if (isMobile) start();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-custom-announcement]').forEach(initAnnouncement);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-custom-announcement]') || e.target.closest('[data-custom-announcement]');
      if (root) {
        root.dataset.ready = 'false';
        root.dataset.modeReady = 'false';
        initAnnouncement(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCustomShop(root) {
      const shops = [];
      if (root && root.matches && root.matches('[data-custom-shop]')) shops.push(root);
      if (root && root.querySelectorAll) root.querySelectorAll('[data-custom-shop]').forEach(function (shop) { shops.push(shop); });

      shops.forEach(function (shop) {
        if (shop.dataset.filtersInitialized === 'true') return;
        shop.dataset.filtersInitialized = 'true';

        // AJAX Quick Add: add products without navigating to the cart page.
        shop.querySelectorAll('[data-quick-add-form]').forEach(function (form) {
          if (form.dataset.quickAddInitialized === 'true') return;
          form.dataset.quickAddInitialized = 'true';

          form.addEventListener('submit', async function (event) {
            event.preventDefault();

            const button = form.querySelector('.custom-card__quick');
            if (!button || button.disabled) return;

            const originalText = button.textContent.trim();
            button.disabled = true;
            button.textContent = 'Adding...';

            try {
              const response = await fetch(
                (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                  ? window.Shopify.routes.root
                  : '/') + 'cart/add.js',
                {
                  method: 'POST',
                  headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: new FormData(form)
                }
              );

              const result = await response.json();

              if (!response.ok) {
                throw new Error(
                  result.description || result.message || 'Could not add this product.'
                );
              }

              button.textContent = 'Added ✓';

              // Update common Shopify cart count elements.
              try {
                const cartResponse = await fetch(
                  (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                    ? window.Shopify.routes.root
                    : '/') + 'cart.js',
                  { headers: { Accept: 'application/json' } }
                );

                if (cartResponse.ok) {
                  const cart = await cartResponse.json();

                  document.querySelectorAll(
                    '#cart-icon-bubble .cart-count-bubble, ' +
                    '.cart-count-bubble, [data-cart-count]'
                  ).forEach(function (element) {
                    const countElement = element.matches('[data-cart-count]')
                      ? element
                      : element.querySelector('span[aria-hidden="true"]') || element;

                    countElement.textContent = cart.item_count;
                    element.classList.toggle('hidden', cart.item_count === 0);
                  });
                }
              } catch (cartUpdateError) {
                console.warn('Product added, but cart count could not be refreshed.', cartUpdateError);
              }

              // Notify themes and apps that listen for cart updates.
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:updated', { bubbles: true, detail: result })
              );
              document.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true, detail: result })
              );
            } catch (error) {
              console.error('Quick add failed:', error);
              button.textContent = 'Try again';
              button.title = error.message || 'Could not add this product.';
            } finally {
              window.setTimeout(function () {
                button.textContent = originalText;
                button.disabled = false;
                button.removeAttribute('title');
              }, 1800);
            }
          });
        });

        const filterForm = shop.querySelector('[data-filter-form]');
        const drawer = shop.querySelector('.custom-filters');
        const openBtn = shop.querySelector('.js-filters-open');
        const closeBtn = shop.querySelector('.js-filters-close');

        if (filterForm) {
          filterForm.addEventListener('change', function (event) {
            const input = event.target;
            if (input.matches('input[type="checkbox"]')) {
              const url = new URL(filterForm.action, window.location.origin);
              const formData = new FormData(filterForm);
              url.search = '';
              formData.forEach(function (value, key) {
                if (value !== '') url.searchParams.append(key, value);
              });
              url.searchParams.delete('page');
              window.location.assign(url.toString());
            }
          });

          filterForm.addEventListener('submit', function (event) {
            const priceFilter = event.submitter && event.submitter.matches('.js-price-apply');
            if (priceFilter) return;
          });

          shop.querySelectorAll('[data-price-filter]').forEach(function (priceFilter) {
            const range = priceFilter.querySelector('.js-price-range');
            const minInput = priceFilter.querySelector('.js-price-min');
            const maxInput = priceFilter.querySelector('.js-price-max');
            const minParam = priceFilter.querySelector('.js-price-min-param');
            const maxParam = priceFilter.querySelector('.js-price-max-param');
            const target = priceFilter.querySelector('.js-range-target');
            if (!range || !maxInput || !maxParam) return;

            const maxMinor = Number(range.max) || 0;
            const toMinor = function (amount) { return Math.max(0, Math.round(Number(amount || 0) * 100)); };
            const toMajor = function (amount) { return Math.ceil(Number(amount || 0) / 100); };
            const formatPrice = function (amount) { const template = target && target.dataset.moneyFormat ? target.dataset.moneyFormat : '0'; const match = template.match(/[0-9][0-9,]*(?:\.[0-9]+)?/); if (!match) return Number(amount).toLocaleString(); const decimals = match[0].includes('.') ? match[0].split('.')[1].length : 0; const formatted = Number(amount).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); return template.replace(match[0], formatted); };

            function syncFromRange() {
              const major = toMajor(range.value);
              maxInput.value = major;
              maxParam.value = range.value >= maxMinor ? '' : range.value;
              if (target) target.textContent = formatPrice(major);
            }

            function applyPrice() {
              let minValue = minInput ? toMinor(minInput.value) : 0;
              let maxValue = toMinor(maxInput.value);
              if (maxValue > maxMinor) maxValue = maxMinor;
              if (minValue > maxValue) minValue = maxValue;
              if (minParam) minParam.value = minValue > 0 ? String(minValue) : '';
              maxParam.value = maxValue >= maxMinor ? '' : String(maxValue);
              const url = new URL(filterForm.action, window.location.origin);
              const formData = new FormData(filterForm);
              url.search = '';
              formData.forEach(function (value, key) {
                if (value !== '') url.searchParams.append(key, value);
              });
              url.searchParams.delete('page');
              window.location.assign(url.toString());
            }

            range.addEventListener('input', syncFromRange);
            range.addEventListener('change', function () {
              if (minParam) minParam.value = minInput && Number(minInput.value) > 0 ? String(toMinor(minInput.value)) : '';
              maxParam.value = Number(range.value) >= maxMinor ? '' : String(range.value);
              applyPrice();
            });
            if (maxInput) maxInput.addEventListener('change', function () {
              let value = toMinor(maxInput.value);
              if (value > maxMinor) value = maxMinor;
              range.value = value;
              syncFromRange();
              applyPrice();
            });
            if (minInput) minInput.addEventListener('change', applyPrice);
          });
        }

        shop.querySelectorAll('.js-sort-select').forEach(function (select) {
          select.addEventListener('change', function () {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', select.value);
            url.searchParams.delete('page');
            window.location.assign(url.toString());
          });
        });

        if (openBtn && drawer) {
          openBtn.addEventListener('click', function () {
            drawer.classList.add('is-open');
            openBtn.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('custom-filter-open');
          });
        }
        if (closeBtn && drawer) {
          closeBtn.addEventListener('click', function () {
            drawer.classList.remove('is-open');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove('custom-filter-open');
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initCustomShop(document); });
    } else {
      initCustomShop(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initCustomShop(event.target); });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('custom-contact-form');
  if (!form) return;

  var msg = form.querySelector('.js-custom-contact-msg');

  form.addEventListener('submit', function (e) {
    var required = form.querySelectorAll('[required]');
    var ok = true;
    required.forEach(function (el) {
      if (!el.value || !String(el.value).trim()) {
        ok = false;
        el.setAttribute('aria-invalid', 'true');
      } else {
        el.removeAttribute('aria-invalid');
      }
    });

    var email = form.querySelector('input[type="email"]');
    if (email && email.value) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!re.test(email.value)) {
        ok = false;
        email.setAttribute('aria-invalid', 'true');
      }
    }

    if (!ok) {
      e.preventDefault();
      if (msg) {
        msg.textContent = 'Please complete every required field with valid details.';
        msg.classList.add('custom-contact__msg--err');
      }
    } else if (msg) {
      msg.textContent = '';
      msg.classList.remove('custom-contact__msg--err');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(root) {
    if (!root || root.dataset.headerReady === 'true') return;

    var toggle = root.querySelector('[data-custom-header-toggle]');
    var drawer = root.querySelector('[data-custom-header-drawer]');
    var overlay = root.querySelector('[data-custom-header-overlay]');
    var closeButton = root.querySelector('[data-custom-header-close]');
    if (!toggle || !drawer) return;

    root.dataset.headerReady = 'true';

    function setOpen(open) {
      if (open) {
        drawer.hidden = false;
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-open');
        });
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Close menu');
        document.body.classList.add('custom-header-menu-open');
        if (closeButton) closeButton.focus();
      } else {
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('custom-header-menu-open');
        window.setTimeout(function () {
          if (!drawer.classList.contains('is-open')) {
            drawer.hidden = true;
            if (overlay) overlay.hidden = true;
          }
        }, 300);
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (closeButton) closeButton.addEventListener('click', function () { setOpen(false); });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });

    root.querySelectorAll('[data-custom-submenu-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var submenu = button.nextElementSibling;
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (submenu) submenu.hidden = expanded;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024 && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.custom-header-wrapper').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches && event.target.matches('.custom-header-wrapper')
      ? event.target
      : event.target.querySelector('.custom-header-wrapper');
    if (root) {
      root.dataset.headerReady = 'false';
      initHeader(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testomonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      if (!root || root.dataset.testimonialsReady === 'true') return;

      var viewport = root.querySelector('[data-testimonials-viewport]');
      var track = root.querySelector('[data-testimonials-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-slide]'));
      var prevBtn = root.querySelector('[data-testimonials-prev]');
      var nextBtn = root.querySelector('[data-testimonials-next]');
      var shell = root.querySelector('.custom-testimonials__slider-shell');

      if (!viewport || !track || !slides.length || !prevBtn || !nextBtn) return;

      var index = 0;
      var timer = null;
      var paused = false;
      var gapDesktop = 48;
      var intervalMs = parseInt(root.getAttribute('data-autoplay-ms') || '3000', 10);
      var mq = window.matchMedia('(max-width: 900px)');

      function isMobile() {
        return mq.matches;
      }

      function perView() {
        return isMobile() ? 1 : 3;
      }

      function maxStart() {
        return Math.max(0, slides.length - perView());
      }

      function canSlide() {
        return slides.length > perView();
      }

      function applyCardWidths() {
        var pv = perView();
        var gap = isMobile() ? 0 : gapDesktop;
        var totalGap = gap * Math.max(0, pv - 1);
        var cardWidth;

        if (isMobile()) {
          cardWidth = '100%';
          track.style.gap = '0px';
        } else {
          track.style.gap = gapDesktop + 'px';
          cardWidth = 'calc((100% - ' + totalGap + 'px) / ' + pv + ')';
        }

        slides.forEach(function (slide) {
          slide.style.flex = '0 0 ' + cardWidth;
          slide.style.width = cardWidth;
          slide.style.maxWidth = cardWidth;
        });
      }

      function update() {
        applyCardWidths();

        if (!canSlide()) {
          index = 0;
          track.style.transform = 'translate3d(0, 0, 0)';
          prevBtn.classList.add('is-hidden');
          nextBtn.classList.add('is-hidden');
          stopAutoplay();
          return;
        }

        prevBtn.classList.remove('is-hidden');
        nextBtn.classList.remove('is-hidden');

        var total = slides.length;
        var pv = perView();
        // Loop page starts so we always show `pv` cards
        var pages = Math.ceil(total / pv);
        if (pages < 1) pages = 1;
        index = ((index % pages) + pages) % pages;

        var start = index * pv;
        // If last page would be short, clamp so last view still fills when possible
        if (start > maxStart()) start = maxStart();

        if (isMobile()) {
          track.style.transform = 'translate3d(' + (-start * 100) + '%, 0, 0)';
        } else {
          var gap = gapDesktop;
          var stepPct = 100 / pv;
          // translate by card widths + gaps via % of viewport using first card size
          var first = slides[0];
          var cardW = first.getBoundingClientRect().width;
          var offset = start * (cardW + gap);
          track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
        }
      }

      function go(delta, fromUser) {
        if (!canSlide()) return;
        var pv = perView();
        var pages = Math.ceil(slides.length / pv);
        index = index + delta;
        index = ((index % pages) + pages) % pages;
        update();
        if (fromUser) restartAutoplay();
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!canSlide() || paused || slides.length < 2) return;
        timer = setInterval(function () {
          if (paused) return;
          go(1, false);
        }, intervalMs);
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      prevBtn.addEventListener('click', function () {
        go(-1, true);
      });

      nextBtn.addEventListener('click', function () {
        go(1, true);
      });

      if (shell) {
        shell.addEventListener('mouseenter', function () {
          paused = true;
          stopAutoplay();
        });
        shell.addEventListener('mouseleave', function () {
          paused = false;
          startAutoplay();
        });
        shell.addEventListener('focusin', function () {
          paused = true;
          stopAutoplay();
        });
        shell.addEventListener('focusout', function () {
          paused = false;
          startAutoplay();
        });
      }

      var startX = 0;
      var deltaX = 0;
      var dragging = false;

      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches.length || !canSlide()) return;
          dragging = true;
          paused = true;
          stopAutoplay();
          startX = e.touches[0].clientX;
          deltaX = 0;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!dragging || !e.touches || !e.touches.length) return;
          deltaX = e.touches[0].clientX - startX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function () {
          if (!dragging) return;
          dragging = false;
          if (Math.abs(deltaX) > 40) {
            go(deltaX < 0 ? 1 : -1, true);
          } else {
            restartAutoplay();
          }
          deltaX = 0;
          paused = false;
        },
        { passive: true }
      );

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else if (!paused) {
          startAutoplay();
        }
      });

      var resizeTimer = null;
      function onChange() {
        index = 0;
        update();
        startAutoplay();
      }

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onChange);
      }

      window.addEventListener(
        'resize',
        function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            update();
          }, 100);
        },
        { passive: true }
      );

      root.dataset.testimonialsReady = 'true';
      update();
      startAutoplay();
    }

    function boot() {
      document.querySelectorAll('[data-testimonials-section]').forEach(initTestimonials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      var section =
        event.target.querySelector('[data-testimonials-section]') ||
        event.target.closest('[data-testimonials-section]');
      if (section) {
        section.dataset.testimonialsReady = 'false';
        initTestimonials(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrust(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      var track = root.querySelector('[data-custom-trust-track]');
      var prevBtn = root.querySelector('[data-custom-trust-prev]');
      var nextBtn = root.querySelector('[data-custom-trust-next]');
      if (!track || !prevBtn || !nextBtn) return;

      function updateArrows() {
        if (window.innerWidth > 749) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 5);
        nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll - 5);
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({
          left: -track.clientWidth,
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({
          left: track.clientWidth,
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });

      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initAll() {
      document.querySelectorAll('[data-custom-trust]').forEach(initTrust);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-custom-trust]') || e.target.closest('[data-custom-trust]');
      if (root) {
        root.dataset.ready = 'false';
        initTrust(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single_product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.custom-pdp-main__section');
    if (!section) return;
    const variants = JSON.parse(document.getElementById('CustomPdpVariantsJson-' + section.dataset.sectionId).textContent);
    
    const mainImg = document.getElementById('CustomPdpMainImage');
    section.querySelectorAll('.custom-pdp-main__thumb-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (mainImg) {
          mainImg.src = btn.dataset.targetSrc;
          mainImg.srcset = btn.dataset.targetSrcset;
        }
        section.querySelectorAll('.custom-pdp-main__thumb-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    const qtyInput = document.getElementById('CustomPdpQty');
    const decBtn = document.getElementById('CustomPdpQtyDec');
    const incBtn = document.getElementById('CustomPdpQtyInc');
    if (qtyInput && decBtn && incBtn) {
      decBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      incBtn.addEventListener('click', () => {
        let val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    section.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', () => {
        const group = input.closest('.custom-pdp-main__option-group');
        const valLabel = group.querySelector('[data-selected-option-value]');
        if (valLabel) valLabel.textContent = input.value;
        group.querySelectorAll('label').forEach(l => l.classList.remove('is-selected'));
        input.closest('label').classList.add('is-selected');

        const selected = Array.from(section.querySelectorAll('input[type="radio"]:checked')).map(i => i.value);
        const match = variants.find(v => v.options.every((o, idx) => o === selected[idx]));
        
        if (match) {
           document.getElementById('CustomPdpVariantId').value = match.id;
           const priceCurr = document.querySelector('[data-price-current]');
           if (priceCurr) priceCurr.textContent = '$' + (match.price / 100).toFixed(2);
           const btn = document.getElementById('CustomPdpAddBtn');
           if (btn) {
             btn.disabled = !match.available;
             btn.querySelector('[data-add-text]').textContent = match.available ? 'ADD TO BAG' : 'SOLD OUT';
           }
           const skuSpan = document.getElementById('CustomPdpSku');
           if (skuSpan) skuSpan.textContent = match.sku || 'N/A';
        }
      });
    });

    const sgBtn = document.getElementById('CustomPdpOpenSizeGuide');
    if (sgBtn) sgBtn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('pdp:open-size-guide')));
  });

  } catch(e) { console.error(e); }
})();
})();
